import { useContext } from 'react';
import { BasketContext } from './basket-context';

export const useBasket = () => {
	return useContext(BasketContext);
};
